"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
var HandleRequest_1 = require("../../../../../common/js/services/requestHttp/HandleRequest");
var CustomerInfo = /** @class */ (function (_super) {
    __extends(CustomerInfo, _super);
    function CustomerInfo($view) {
        var _this = _super.call(this, $view) || this;
        _this.$submitUpdateInfo = _this.$view.find("#bSubmitInfo");
        _this.$submitUpdatePassword = _this.$view.find("#bSubmitPassword");
        _this.$formUserInfo = _this.$view.find("#userInfo");
        _this.$formUserPassword = _this.$view.find("#userPassword");
        _this.$blockError = _this.$view.find("#block_no_valide_form");
        _this.$blockErrorMessage = _this.$blockError.find("#no_valide_form");
        _this.$blockSuccess = _this.$view.find("#block_valide_form");
        _this.$blockSuccessMessage = _this.$blockSuccess.find("#valide_form");
        _this.$blockErrorPassword = _this.$view.find("#block_no_valide_form_password");
        _this.$blockErrorMessagePassword = _this.$blockErrorPassword.find("#no_valide_form_password");
        _this.$blockSuccessPassword = _this.$view.find("#block_valide_form_password");
        _this.$blockSuccessMessagePassword = _this.$blockSuccessPassword.find("#valide_form_password");
        _this.initListeners();
        return _this;
    }
    CustomerInfo.prototype.initListeners = function () {
        this.updateInfos();
        this.updatePassword();
    };
    CustomerInfo.prototype.updateInfos = function () {
        var _this = this;
        this.$submitUpdateInfo.on('click', function (e) { return __awaiter(_this, void 0, void 0, function () {
            var $button, method, formData, response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        this.$blockError.addClass('d-none');
                        this.$blockSuccess.addClass('d-none');
                        $button = $(e.target);
                        method = 'POST';
                        formData = new FormData(this.$formUserInfo.get(0));
                        formData.append("action", $button.attr("value"));
                        return [4 /*yield*/, (0, HandleRequest_1.send)(this.$formUserInfo.attr("action"), method, formData)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        if (response.ok) {
                            this.showFormSuccessMessage(data.message);
                        }
                        else {
                            if (data.message !== undefined && data.message.length > 0) {
                                this.showFormErrorMessage(data.message);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    CustomerInfo.prototype.updatePassword = function () {
        var _this = this;
        this.$submitUpdatePassword.on('click', function (e) { return __awaiter(_this, void 0, void 0, function () {
            var $button, method, formData, response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        $button = $(e.target);
                        method = 'POST';
                        formData = new FormData(this.$formUserPassword.get(0));
                        formData.append("action", $button.attr("value"));
                        return [4 /*yield*/, (0, HandleRequest_1.send)(this.$formUserPassword.attr("action"), method, formData)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        if (response.ok) {
                            this.showFormSuccessMessagePassword(data.message);
                        }
                        else {
                            if (data.message !== undefined && data.message.length > 0) {
                                this.showFormErrorMessagePassword(data.message);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    CustomerInfo.prototype.showFormErrorMessage = function (message) {
        this.$blockErrorMessage.html(message);
        this.$blockError.removeClass('d-none');
    };
    CustomerInfo.prototype.showFormSuccessMessage = function (message) {
        this.$blockSuccessMessage.html(message);
        this.$blockSuccess.removeClass('d-none');
    };
    CustomerInfo.prototype.showFormErrorMessagePassword = function (message) {
        this.$blockErrorMessagePassword.html(message);
        this.$blockErrorPassword.removeClass('d-none');
    };
    CustomerInfo.prototype.showFormSuccessMessagePassword = function (message) {
        this.$blockSuccessMessagePassword.html(message);
        this.$blockSuccessPassword.removeClass('d-none');
    };
    return CustomerInfo;
}(BaseComponent_1.default));
exports.default = CustomerInfo;
